window.addEventListener("load", (event) => {
  document.addEventListener("variant:change", (event) => {
    console.log('triggered');
    
    const selectedVariantId = event.detail.variant.id;
    const numberOfInputFields = window.variantMatches[selectedVariantId];

    // Select all the input elements
    const allInputs = document.querySelectorAll('.line-item-property.ct-textfields');

    // Loop through all input elements
    allInputs.forEach((input, index) => {
      if (index < numberOfInputFields) {
        // Show the input up to the number specified
        input.style.display = 'block';
      } else {
        // Hide the other inputs
        input.style.display = 'none';
      }
    });
  });
});

